module.exports = __webpack_public_path__ + "static/media/4ODA10.b55096ea.jpg";